"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiListItem = {
    styleOverrides: {
        root: {
            '&:hover': {
                backgroundColor: colors_1.default.lightOrange,
            },
            '&.Mui-selected': {
                '&:hover': {
                    backgroundColor: colors_1.default.lightOrange,
                },
                '&:focus': {
                    backgroundColor: colors_1.default.lightOrange,
                },
            },
        },
    },
};
exports.default = muiListItem;
//# sourceMappingURL=muiListItem.js.map